var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.1116 39.3882L32.6479 29.8333L23.1116 20.2785C22.8841 20.0505 22.7036 19.7798 22.5805 19.4819C22.4573 19.1841 22.3939 18.8648 22.3939 18.5424C22.3939 18.2199 22.4573 17.9007 22.5805 17.6028C22.7036 17.3049 22.8841 17.0342 23.1116 16.8062C23.3392 16.5782 23.6093 16.3974 23.9066 16.274C24.2039 16.1506 24.5226 16.0871 24.8444 16.0871C25.1662 16.0871 25.4848 16.1506 25.7821 16.274C26.0794 16.3974 26.3496 16.5782 26.5771 16.8062L37.8584 28.1095C38.8169 29.0699 38.8169 30.6214 37.8584 31.5818L26.5771 42.8851C26.3498 43.1133 26.0797 43.2945 25.7823 43.418C25.485 43.5416 25.1663 43.6052 24.8444 43.6052C24.5225 43.6052 24.2038 43.5416 23.9064 43.418C23.6091 43.2945 23.339 43.1133 23.1116 42.8851C22.1777 41.9246 22.1531 40.3486 23.1116 39.3882Z",
    fill: "#498CCE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRight);
export default __webpack_public_path__ + "static/media/arrow-right.26258e5df9c9d00496f61a311a8eb953.svg";
export { ForwardRef as ReactComponent };